import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStoreList } from "../../../Redux/Reducer/StoreListReducer";
import { ArrowLeftIcon, SearchIcon } from "@heroicons/react/solid";
import Cookies from "js-cookie";
import Login from "../UserAuth/Login/Login";
import { CheckCircleIcon, PencilAltIcon } from "@heroicons/react/outline";
import axiosInstance from "../../../Service/Interceptor";
import { toast, ToastContainer } from "react-toastify";
import { safeUseLayoutEffect } from "react-table";
import loader from "../../../assets/loader.gif";
import { getVendorAnalytics } from "../../../Redux/Reducer/VendorAnalyticsReducer";

const AllHightOrderStores = () => {
  let token = Cookies.get("access_token");
  const baseUrl = process.env.REACT_APP_BASE_URL_TWO;
  const dispatch = useDispatch();
  const [loadMore, setLoadMore] = useState(1);
  const [effect, setEffect] = useState(0);

  const [highestOrder, setHighestOrder] = useState([]);

  useEffect(() => {
    axiosInstance
      .get("orders/api/v1/orders/regional_admin/vendor-overview/")
      .then((res) => {
        setHighestOrder(res.data.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      {token ? (
        <>
          <section className="justify-center h-full w-full pt-2 pb-6 px-4 bg-white">
            <div className="col-span-12 flex justify-between items-center w-full  mb-5">
              <p className="text-xl font-semibold ">
                All Highest Rated Stoes List
              </p>
              <button
                className="flex justify-start items-center text-white text-sm bg-blue-600 font-medium  px-2 py-1 shadow-2xl cursor-pointer rounded-md"
                onClick={() => window.history.back()}
              >
                <ArrowLeftIcon className="w-4 mx-1" /> Back
              </button>
            </div>

            <div className="grid grid-cols-12 gap-x-4 mb-5  ">
              <div className="col-span-6  space-y-3  gap-x-8   rounded-md  p-4  bg-white drop-shadow-[0px_8px_10px_rgba(44,141,255,0.29)] text-gray-800 mb-2 shadow-lg">
                {highestOrder?.map((item, index) => (
                  <div
                    className="px-5 py-1 bg-gray-200 rounded-md shadow-md"
                    key={index}
                  >
                    <p className="font-bold text-md">{item.vendor_shopname}</p>
                    <p className="text-xs ">
                      <span className="text-md font-bold">
                        {" "}
                        {item.total_successful_orders}{" "}
                      </span>{" "}
                      Successful Order Completed
                    </p>
                  </div>
                ))}
              </div>

              {/* <div className="col-span-12  flex  justify-end  items-end gap-x-8  rounded-md  w-full  mb-2">
                  {activeStoreData?.previous !== null && (
                    <button
                      type="submit"
                      class="group relative flex w-auto justify-center rounded-md border border-transparent bg-red-600 py-1 px-2 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                      onClick={() => setLoadMore(loadMore - 1)}
                    >
                      Previous{" "}
                    </button>
                  )}

                  {activeStoreData?.next !== null && (
                    <button
                      type="submit"
                      class="group relative flex w-auto justify-center rounded-md border border-transparent bg-green-600 py-1 px-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                      onClick={() => setLoadMore(loadMore + 1)}
                    >
                      next{" "}
                    </button>
                  )}
                </div> */}
            </div>
          </section>
        </>
      ) : (
        <Login />
      )}
    </>
  );
};

export default AllHightOrderStores;
